'use client'
import React from 'react'
import NextImage from 'next/image'

import { OpeningTitle } from '@dynamo-caffeina-dev/airc-ui-kit'

import footerMock from '@/fixtures/footer'

import Logo from '@/components/atoms/Logo'
import Container from '@/components/atoms/Container'

import Navigation from '@/components/molecules/Navigation'
import {
  AggregatedMenusResponseType,
  LayoutDirectionType,
  PatchedMenuType,
  PatchedSocialMediaMenuType,
} from '@/types'

function isSocialMenu(
  menu: PatchedMenuType | PatchedSocialMediaMenuType
): menu is PatchedSocialMediaMenuType {
  return Boolean(
    menu?.items?.every((menuItem) => !!menuItem && 'social' in menuItem)
  )
}

const Footer = ({
  items: aggregatedMenus,
}: {
  items: Partial<AggregatedMenusResponseType>
}) => {
  return (
    <footer className='airc-footer'>
      <Container>
        {/* HARDCODED PART */}
        <div className='airc-footer--company'>
          <Logo position='footer' />

          <strong
            dangerouslySetInnerHTML={{ __html: footerMock.company.payoff }}
          />

          <p>
            {footerMock.company.description.replace(
              '{currentYear}',
              String(new Date().getFullYear())
            )}
          </p>
        </div>

        <div className='airc-footer--menus'>
          <div className='airc-footer--partner'>
            <OpeningTitle
              as='h3'
              size='sm'
              style={{
                textAlign: 'left',
                margin: 0,
              }}
            >
              Partner
            </OpeningTitle>

            <NextImage
              src='/partner-logo.png'
              alt='Banco BPM'
              width={168}
              height={64}
            />
          </div>

          {/* DYNAMIC PART */}
          {Object.values(aggregatedMenus ?? {})?.map?.((menu, index) => {
            const _menu = isSocialMenu(menu)
              ? {
                  direction: 'row' as LayoutDirectionType,
                  // truthiness was already asserted in the type guard
                  ...menu,
                }
              : {
                  direction: 'column' as LayoutDirectionType,
                  ...(menu ?? {}),
                }

            return (
              <div
                className='airc-footer--menu'
                key={index}
              >
                <OpeningTitle
                  as='h3'
                  size='sm'
                  style={{
                    textAlign: 'left',
                    margin: 0,
                  }}
                >
                  {_menu.title}
                </OpeningTitle>

                <span>{menu.description}</span>

                <Navigation menu={_menu} />
              </div>
            )
          })}
        </div>
      </Container>
    </footer>
  )
}

export default Footer
